function Footer(){
    
    return (
    <div className="footer">
        <div className="copy">
        <a href="https://github.com/fnanoia">Written by Francisco Nanoia. 2022</a>
        </div>
    </div>
    )
};

export default Footer;